export default __webpack_public_path__ + "static/media/tanjug.2c8be253.png";